import * as yup from "yup";

export const agregarOrdenCompra = yup.object().shape({
    ordenCompra: yup.string().required(),
    viajesTotales: yup.number().required()
});